import React, { FC } from 'react';

interface RollsRemainingProps {
  /**
   * Number of rolls remaining
   *
   * @default "-"
   **/
  rollsRemaining?: number | string;

  /**
   * Width
   *
   * @default "44px"
   **/
  width?: string;

  /**
   * Height
   *
   * @default "45px"
   **/
  height?: string;
}

const rollsRemaining: FC<RollsRemainingProps> = ({
  width = '44px',
  height = '45px',
  rollsRemaining: remainingRolls,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 45"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Rolls Remaining</title>
      <defs>
        <filter
          x="-12.5%"
          y="-12.2%"
          width="125.0%"
          height="124.7%"
          filterUnits="objectBoundingBox"
          id="filter-1"
        >
          <feOffset dx="2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 1 0"
            type="matrix"
            in="shadowOffsetOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Components/WelcomeBackRolls" transform="translate(-81.000000, -558.000000)">
          <g transform="translate(-10.000000, -29.000000)" id="Welcome_Back">
            <g>
              <g id="RRROLL-Button" transform="translate(85.000000, 585.000000)">
                <g id="Group-2">
                  <g id="Group-2-Copy" transform="translate(7.000000, 3.000000)">
                    <g
                      id="Roll-Up-Logo-01"
                      filter="url(#filter-1)"
                      fill="#FBFBFB"
                      fillRule="nonzero"
                      stroke="#000000"
                      strokeWidth="2"
                    >
                      <g id="Rolls">
                        <path
                          d="M39.7695236,10.3318813 L30.1057044,0.231454588 C29.6639158,-0.22975588 28.8905817,0.0408649313 28.8260691,0.67946404 L28.0960155,7.91857074 C27.0834132,7.20076554 25.9809832,6.5786677 24.7952586,6.07207874 C22.5324191,5.10510438 20.183835,4.64719416 17.8719986,4.64801923 C10.9373059,4.64884429 4.34477489,8.77003622 1.47437397,15.6296137 C-1.01466785,21.5766711 -0.09352639,28.116949 3.34360518,33.0277267 C3.34360518,33.0285517 3.34442179,33.0285517 3.34442179,33.0293768 C3.7372135,33.591245 4.16348641,34.1308365 4.62079068,34.6465012 C4.62814021,34.6555768 4.63630636,34.6638275 4.64447251,34.6729032 C4.94090367,35.0054038 5.25121728,35.3280036 5.57378012,35.6398775 C5.58766257,35.6530786 5.60154502,35.6662796 5.61542747,35.6803057 C5.77466735,35.8329424 5.93717369,35.983929 6.10294649,36.1307903 C6.11192925,36.1390409 6.12091201,36.1464665 6.12989478,36.1538921 C6.2915845,36.296628 6.45572407,36.4377139 6.6231301,36.5746744 C6.6345627,36.5837501 6.6451787,36.5928258 6.65579469,36.6019015 C6.82320072,36.7388621 6.99305659,36.8725223 7.16617892,37.0028824 C7.19231059,37.0226839 7.21844226,37.0424854 7.24539055,37.0622869 C7.5908186,37.3213569 7.94686264,37.5688759 8.31352267,37.804019 C8.34700388,37.8254706 8.37966847,37.8469223 8.41314967,37.8675489 C8.59198831,37.9805825 8.77327679,38.091141 8.95701511,38.1975742 C8.98478001,38.2132504 9.01254492,38.2289266 9.04030982,38.2454279 C9.21016569,38.3427854 9.38165479,38.4376677 9.55477712,38.5300748 C9.58417526,38.545751 9.61275677,38.5614272 9.6421549,38.5771034 C9.82915969,38.675286 10.0194309,38.7701683 10.2113354,38.8625754 C10.2529828,38.8823769 10.2946301,38.9021784 10.3362775,38.9219799 C10.5338982,39.0152121 10.7323356,39.1059691 10.9348561,39.1917757 C11.2002559,39.3048094 11.4664723,39.4104175 11.7335053,39.5102502 C11.7441213,39.5143755 11.7547373,39.5185008 11.7653533,39.5226261 C12.0274866,39.6191586 12.28962,39.7090905 12.5533866,39.7924219 C12.5680856,39.7973723 12.5827847,39.8023226 12.5983004,39.807273 C12.8604337,39.8897794 13.1233837,39.9648601 13.3871502,40.0349905 C13.4018493,40.0391159 13.417365,40.0432412 13.4320641,40.0473665 C13.6966472,40.1166718 13.962047,40.1785516 14.2282635,40.235481 C14.2413293,40.2379561 14.2543951,40.2412564 14.267461,40.2437316 C14.5361272,40.2998359 14.8047935,40.3493397 15.0734597,40.3930681 C15.0832591,40.3947182 15.0930585,40.3963683 15.1028579,40.3980185 C15.3756072,40.4417468 15.6475399,40.4780496 15.9202893,40.508577 C15.9260056,40.509402 15.9325385,40.5102271 15.9382548,40.5102271 C16.2142706,40.5407544 16.4894698,40.5646813 16.7654855,40.5820076 C16.7679354,40.5820076 16.7703852,40.5820076 16.7728351,40.5828327 C17.135412,40.6051094 17.4971724,40.6183104 17.8589327,40.6183104 C17.8687321,40.6183104 17.8777149,40.6174853 17.8875142,40.6174853 C17.8924139,40.6174853 17.8973136,40.6174853 17.9030299,40.6174853 C17.9503936,40.6174853 17.9977572,40.6166603 18.0459375,40.6158352 C18.1153498,40.6150101 18.1855786,40.6141851 18.2549909,40.6125349 C18.3097041,40.6117099 18.3660505,40.6084096 18.4207637,40.6067595 C18.4705772,40.6051094 18.5203907,40.6034593 18.5693876,40.6018091 C19.7371467,40.5580808 21.0200485,40.4087443 22.3617466,40.1595751 C28.5165721,38.8988782 34.1275322,35.0722339 37.2739489,29.2101581 C40.3525866,23.4759671 40.3542198,17.4389779 38.1918239,11.9003269 L39.4167461,11.5909281 C39.9720441,11.4473671 40.1696649,10.7493634 39.7695236,10.3318813 Z"
                          id="Path"
                        />
                      </g>
                    </g>
                    <path
                      d="M37.1325949,12.3722656 L38.2890921,12.0765225 C38.8156839,11.9416637 39.0022654,11.2744674 38.6244763,10.8754114 L29.5004843,1.22078112 C29.0833743,0.77992682 28.353239,1.0386034 28.2923302,1.64901705 L27.0664431,13.9535051 C27.0170992,14.4503534 27.4650492,14.847832 27.939213,14.7263802 L29.1172982,14.4251166 C30.6847374,18.5552668 30.4996979,22.9543461 28.2799942,27.1420676 C24.199101,34.837696 13.8592449,37.5403931 6.03284274,33.1980965 C5.09145401,32.6760115 4.26186,32.0955665 3.52941176,31.462282 C5.29653951,34.4867476 7.98423905,36.9843962 11.3997608,38.4623228 C13.4583259,39.3527065 15.5932197,39.7904062 17.6980447,39.8211635 C17.7913354,39.8219521 17.8838552,39.8235294 17.977146,39.8235294 C18.0218639,39.8235294 18.0665818,39.8227408 18.1120707,39.8219521 C18.1776055,39.8211635 18.2439114,39.8203748 18.3094462,39.8187975 C19.4898444,39.7927721 20.8059382,39.6460836 22.1875669,39.3858297 C27.9985799,38.1807754 33.2961081,34.5230254 36.266764,28.9196805 C39.172656,23.4369987 39.174198,17.6664604 37.1325949,12.3722656 Z"
                      id="ARROW_2_"
                      fill="#FCE200"
                      fillRule="nonzero"
                    />
                    <text
                      id="2"
                      textAnchor="middle"
                      fontSize="19"
                      fontWeight="heavy"
                      line-spacing="20"
                      letterSpacing="-0.285"
                      fill="#000000"
                      data-testid="remaining-rolls"
                    >
                      <tspan x="45%" y="28.2647059">
                        {remainingRolls}
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default rollsRemaining;
